import { render } from "./DeleteModal.vue?vue&type=template&id=5f653dc7"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/DeleteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f653dc7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f653dc7', __exports__)) {
    console.log('reload')
    api.reload('5f653dc7', __exports__)
  }
  
  module.hot.accept("./DeleteModal.vue?vue&type=template&id=5f653dc7", () => {
    console.log('re-render')
    api.rerender('5f653dc7', render)
  })

}


export default __exports__